<template>
    <b-card no-body>
        <b-modal id="assign" title="Güncelle" no-close-on-esc no-close-on-backdrop>
            <garage-salary-multi-assign v-model="assignData"/>
            <template #modal-footer><v-executer :loading="loading" :action="assign">Ata</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    :add-callback="createNew"
                    pagination="server">
                <template #additional-actions>
                    <div class="row">
                        <!-- <div class="col-md-3">
                            <v-select-list :options="salaryTypes" label="Maaş Tipi" v-model="salaryTypeCode" placeholder="Maaş Tipi"></v-select-list>
                        </div> -->
                        <div class="col-md-3">
                            <v-select-list :options="branches" v-on:input="getGarages" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                        </div>
                        <div class="col-md-3">
                            <v-select-list :options="garages" label="GarageName" v-model="garage" placeholder="Tüm Garajlar"></v-select-list>
                        </div>
                    </div>
                </template>
                </v-table>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VehicleOperationsApi from '@/api/vehicle-operations'
import CompanyApi from '@/api/company'
import { BCard } from 'bootstrap-vue'
import GarageSalaryMultiAssign from './components/GarageSalaryMultiAssign.vue'

export default {
    components:{
        BCard,
        GarageSalaryMultiAssign
    },
    data(){
        return {
            fields:[
                {name:"Garaj",key:"GarageName",thClass:"w-20",tdClass:'text-nowrap'},
                {name:"Son Geçerlilik Tarihi",key:"DateStr",thClass:"w-20",tdClass:'text-nowrap'},
                {name:"Atanan Maaş",key:"SalaryStr",thClass:"w-10",tdClass:'text-nowrap'},
                {name:"Net",key:"NETTEN_GIT",thClass:"w-10",tdClass:'text-nowrap'},
                {name:"Asgari Ücret",key:"ASGARI_UCRETLI",thClass:"w-10",tdClass:'text-nowrap'},
                {name:"Maaş Tipi",key:"UCRET_NEVI",thClass:"w-10",tdClass:'text-nowrap'},
                {name:"Maaş Sayısı",key:"SalariesCount",thClass:"w-10",tdClass:'text-nowrap'},
            ],
             buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:(item)=>this.delete(item.Id),thClass:"w-5"},
            ],
            garages:[],
            salaryTypeCode:null,
            branches:[],
            branch:null,
            garage:null,
            loading:false,
            assignData:{
                Id: null,
                BranchId: null,
                VehicleInventoryGarageId: null,
                Salary: null,
                Date: null,
                ASGARI_UCRETLI: false,
                NETTEN_GIT: false,
                UCRET_NEVI: null,
                Date:null,
                SGK:null,
                Month:null,
                Year:null
            }
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        delete(id){
            this.$confirm("Atamayı silmek istediğinizden emin misiniz?",`Bu işlem seçili maaş atamasını silecek ve kapsadığı tüm personellerin maaşını varsa bir önceki maaşa güncelleyecektir.`).then(result=>{
                if(result){
                        this.loading = true
                    EmployeeOperationsApi.GarageSalaryMulti.Delete(id).then(res => {
                        this.loading = false
                        this.$result(res)
                        this.$refs.table.refresh()
                    }).catch(err => {
                        this.loading = false
                        this.$result(null,err)
                    })
                }
            })           
        },
        clearForm(){
            this.assign.Id = null
            this.assign.BranchId = null
            this.assign.VehicleInventoryGarageId = null
            this.assign.Salary = null
            this.assign.Date = null
            this.assign.ASGARI_UCRETLI = false
            this.assign.NETTEN_GIT = false
            this.assign.UCRET_NEVI = null
            this.assign.Date = null
            this.assign.SGK = null 
            this.assign.Month = null
            this.assign.Year = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('assign')
        },
        provider(data){
            return EmployeeOperationsApi.GarageSalaryMulti.Table({
                ...data,
                BranchId: this.branch?.Id || null,
                GarageId: this.garage?.Id || null
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode('O').then(res=>{ 
                this.garage = null
                this.garages = []
                this.branches = res.data.Data
            })
        },
        getGarages(){
            if(this.branch?.Id){
                VehicleOperationsApi.Garage.ListByBranch(this.branch?.Id).then(res=>{
                    this.garages = res.data.Data
                })
            }
        },
        assign(){
            this.loading = true
            EmployeeOperationsApi.GarageSalaryMulti.Assign(this.assignData).then(res => {
                if(res.data.Success){
                    this.$hideModal('assign')
                }
                this.loading = false
                this.$result(res)
                this.$refs.table.refresh()
            }).catch(err => {
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>